import classNames from "classnames";
import { CSSProperties, FC, useContext } from "react";
import useBreakpoint from "../../hooks/useBreakpoint";
import { deviceTypeContext } from "../../utils/deviceTypeContext";
import EmailShareIcon from "./EmailShareIcon";
import FacebookShareIcon from "./FacebookShareIcon";
import TwitterShareIcon from "./TwitterShareIcon";
import UrlToClipboard from "./UrlToClipboard";
import WhatsAppShareIcon from "./WhatsAppShareIcon";

type ShareProps = {
  isOpen: boolean;
  buttonRef: any;
  iconColor?: string;
  backgroundColor?: string;
};

const getConditionalStyles = (
  isOpen: boolean,
  isAboveMd: boolean
): CSSProperties => {
  if (!isOpen)
    return {
      transform: "scaleY(0) translateX(-50%)",
      left: isAboveMd ? "auto" : "50%",
      opacity: 0,
    };
  return {
    transform: "scaleY(1) translateX(-50%)",
    left: isAboveMd ? "auto" : "50%",
    opacity: 1,
  };
};

const Share: FC<ShareProps> = (props) => {
  // TODO: Use fresnel insteadQuery
  const isAboveMd = useBreakpoint("md", useContext(deviceTypeContext)!);

  return (
    <div
      className={classNames("translate-y-7", "z-10", {
        ["absolute left-0 right-0"]: !isAboveMd,
      })}
    >
      <div
        className={classNames(
          "absolute",
          "bg-gray-100",
          "ease-in",
          "duration-100",
          "py-3",
          "px-5",
          "gap-8",
          "flex",
          "justify-evenly",
          "items-center",
          "drop-shadow-lg"
        )}
        style={{
          transitionProperty: "transform, opacity",
          transformOrigin: "top",
          backgroundColor: props.backgroundColor || undefined,
          ...getConditionalStyles(props.isOpen, isAboveMd),
        }}
      >
        <FacebookShareIcon color={props.iconColor || "black"} />
        <TwitterShareIcon color={props.iconColor || "black"} />
        <EmailShareIcon color={props.iconColor || "black"} />
        <WhatsAppShareIcon color={props.iconColor || "black"} />
        <UrlToClipboard color={props.iconColor || "black"} />
      </div>
    </div>
  );
};

export default Share;
